import { useNavigate } from 'react-router-dom';
import { Card, Button } from '@shared/components/ui';
import { SimpleWizardContainer } from '@features/backups/components/simple-wizard/SimpleWizardContainer';
import { Sparkles, Check, ExternalLink, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function QuickBackup() {
  const { t } = useTranslation('backups');
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSuccess = () => {
    setShowSuccess(true);
  };

  const handleViewConfigs = () => {
    navigate('/backups/configs');
  };

  const handleCreateAnother = () => {
    window.location.reload();
  };

  if (showSuccess) {
    return (
      <div className="space-y-8 animate-in fade-in duration-300">
        <Card className="p-8 text-center max-w-2xl mx-auto">
          <div className="w-16 h-16 bg-state-ok-bg-light dark:bg-state-ok-bg-dark rounded-full flex items-center justify-center mx-auto mb-4">
            <Check size={32} className="text-state-ok-light dark:text-state-ok-dark" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
            {t('simpleWizard.success.title')}
          </h2>
          <p className="text-text-muted-light dark:text-text-muted-dark mb-6">
            {t('simpleWizard.success.message')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={handleViewConfigs} variant="primary">
              <ExternalLink size={18} className="mr-2" />
              {t('simpleWizard.success.viewConfigs')}
            </Button>
            <Button onClick={handleCreateAnother} variant="secondary">
              <Plus size={18} className="mr-2" />
              {t('simpleWizard.success.createAnother')}
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-8 animate-in fade-in duration-300">
      <div>
        <h1 className="text-4xl font-black text-slate-900 dark:text-white tracking-tight">
          {t('simpleWizard.title')}
        </h1>
        <p className="text-text-muted-light dark:text-text-muted-dark font-medium mt-1">
          {t('simpleWizard.subtitle')}
        </p>
      </div>

      <Card className="p-6 sm:p-8">
        <div className="flex items-center justify-center gap-2 mb-8 pb-6 border-b border-surface-border-light dark:border-surface-border-dark">
          <Sparkles size={16} className="text-state-warn-light dark:text-state-warn-dark" />
          <span className="text-sm font-medium text-slate-600 dark:text-text-subtle-dark">
            {t('simpleWizard.onlyThreeSteps')}
          </span>
        </div>

        <SimpleWizardContainer onSuccess={handleSuccess} />
      </Card>

      <div className="text-center">
        <p className="text-sm text-text-subtle-light dark:text-text-subtle-dark">
          {t('simpleWizard.needAdvanced')}{' '}
          <button
            type="button"
            onClick={() => navigate('/backups/configs', { state: { openCreateWizard: true } })}
            className="inline-flex min-h-11 items-center text-brand-600 dark:text-brand-400 hover:text-brand-700 dark:hover:text-brand-300 font-medium underline"
          >
            {t('simpleWizard.useAdvancedWizard')}
          </button>
        </p>
      </div>
    </div>
  );
}
